import React from 'react';
import { ControlsQuery } from 'src/graphql/_generated';
import { linkifyText, Spacer } from 'src/common';
import { formatDate } from 'src/utils/misc';
import { Label, Wrap } from './styles';

type ControlGql = ControlsQuery['controls'][number];

interface TableSheetRmpProps {
  data: ControlGql;
}

export const TableSheetRmp: React.FC<TableSheetRmpProps> = ({ data }) => {
  const frameworkData = data.frameworkControls || [];

  return (
    <Wrap>
      <div className="grid grid--2">
        <div>
          <Label>STRATEGY</Label>
          <div className="value">{data.strategy}</div>
        </div>
        <div>
          <Label>NAME</Label>
          <div className="value">{data.name}</div>
        </div>
      </div>
      <Spacer $px={10} />
      {frameworkData.map((el, idx) => (
        <>
          <div className="grid grid--2">
            <div key={el.id}>
              <Label>CONTROL ID ({idx + 1})</Label>
              <div className="value">{el.control_identifier}</div>
            </div>
            <div key={el.id}>
              <Label>FRAMEWORK</Label>
              <div className="value">{el.controlFramework?.shortname}</div>
            </div>
          </div>
          <Spacer $px={10} />
        </>
      ))}

      <div className="grid grid--3">
        <div>
          <Label>OWNER</Label>
          <div className="value">{data.owner?.text}</div>
        </div>
        <div>
          <Label>STATUS</Label>
          <div className="value">{data.status}</div>
        </div>
        <div>
          <Label>EXPECTED LIVE DATE</Label>
          <div className="value">{formatDate(data.expectedActiveDate)}</div>
        </div>
      </div>
      <Spacer $px={10} />
      <Label>DESCRIPTION</Label>
      <div className="value">{data.description ? linkifyText(data.description) : null}</div>
    </Wrap>
  );
};
